import { render, staticRenderFns } from "./Voiceprint.vue?vue&type=template&id=45342e0e&scoped=true"
import script from "./Voiceprint.vue?vue&type=script&lang=js"
export * from "./Voiceprint.vue?vue&type=script&lang=js"
import style0 from "./Voiceprint.vue?vue&type=style&index=0&id=45342e0e&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45342e0e",
  null
  
)

export default component.exports